import clsx from 'clsx'

import { isDevelopment } from '@/utils/isDevelopment'

import { Link } from '@/components/CustomLink'
import { SidebarGroup } from '@/components/Marketplace/SidebarGroup'
import { Warning } from '@/components/Warning'

import { useEntry } from '../Theme.hooks'

type Props = {
	className?: string
	supportTitle?: string
	supportText?: string
	mainSiderbarTitle?: string
	secondarySiderbarTitle?: string
}

export const ThemeDetailsSidebar = ({
	className,
	supportText = 'Documentation for this theme can be found here:',
	supportTitle = 'Support & Documentation',
	mainSiderbarTitle = 'Featured:',
	secondarySiderbarTitle = 'Optimized for:'
}: Props) => {
	const entry = useEntry()

	if ('error' in entry) {
		if (isDevelopment()) return <Warning className={className}>{entry.error}</Warning>
		return null
	}

	return (
		<div className={clsx(className, 'w-full lg:w-1/4 lg:ml-16 pt-20 lg:pt-0')}>
			<SidebarGroup title={mainSiderbarTitle} bullets={entry.data?.themeFeatures} />

			<SidebarGroup title={secondarySiderbarTitle} bullets={entry.data?.themeOptimizations} />

			<h2 className="text-bc-black pb-4 border-b border-b-gray-1000">{supportTitle}</h2>

			{entry.data?.documentationUrl && (
				<p className="text-gray-500 text-xs font-normal mt-4">
					{supportText}:&nbsp;
					<Link
						href={entry.data?.documentationUrl}
						className="text-bc-blue text-xs font-medium mb-1"
						dataTestId="theme-documentation-link"
					>
						{entry.data?.title + ' Documentation'}
					</Link>
				</p>
			)}
		</div>
	)
}
